module.exports = __webpack_public_path__ + "img/marco_d.226f419e.png";